import SNLogoSVG from "../images/_svgs/stay-nimble-mobile.svg";
import certifiedImage from "../images/certified-circle-badge.png";

import SVGImage from "./SVGImage";
import { useMemo } from "react";
import Image from "./Image";
import Icon from "./Icon";

const FooterSlim = () => {
	const date = useMemo(() => {
		const d = new Date();
		return d.getFullYear();
	}, []);

	return (
		<>
			<footer id="footer" className="shadow-footer bg-gray-white py-1 px-2">
				<div
					id="footer-container"
					className="container d-flex flex-column-reverse flex-lg-row align-items-center"
				>
					<div
						id="footer-left"
						className="flex-grow-1 d-flex align-items-center py-2 py-lg-0"
					>
						<div id="footer-logo" className=" flex-grow-0">
							<SVGImage width="47" height="40" alt="Stay Nimble">
								<SNLogoSVG/>
							</SVGImage>
						</div>
						<div id="footer-content-rights" className="px-7 flex-grow-0">
							<small>
								©<span>{date}</span> Stay Nimble. All rights reserved.
							</small>
						</div>
						<div id="footer-icons" className="flex-grow-1 text-center">
							<Image
								src={certifiedImage}
								alt="Certified Social Enterprise"
								width={54}
								height={54}
							/>
						</div>
					</div>
					<div
						id="footer-right"
						className="d-flex flex-nowrap py-2 py-lg-0 justify-content-center justify-content-lg-end"
					>
						<ul
							id="social-links"
							className="list-unstyled my-0 py-0 pl-0 pr-0 d-flex align-items-center"
						>
							<li className="px-2 px-sm-3">
								<a
									href="https://www.linkedin.com/company/stay-nimble/"
									target="_blank"
									rel="noreferrer"
								>
									<Icon name="linkedin"/>
								</a>
							</li>
							<li className="px-2 px-sm-3">
								<a
									href="https://www.facebook.com/staynimble/"
									target="_blank"
									rel="noreferrer"
								>
									<Icon name="facebook"/>
								</a>
							</li>
							<li className="px-2 px-sm-3">
								<a
									href="https://twitter.com/StayNimble"
									target="_blank"
									rel="noreferrer"
								>
									<Icon name="twitter"/>
								</a>
							</li>
							<li className="pl-2 pl-sm-3 pr-2 pr-sm-3 pr-md-0">
								<a
									href="https://www.instagram.com/staynimblecareers/"
									target="_blank"
									rel="noreferrer"
								>
									<Icon name="instagram"/>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</footer>
		</>
	);
};

export default FooterSlim;
